const ActionsTypes = {
	// account
	GET_ACCOUNT: 'GET_ACCOUNT',
	GET_ACCOUNT_SUCCESS: 'GET_ACCOUNT_SUCCESS',
	GET_ACCOUNT_FAILURE: 'GET_ACCOUNT_FAILURE',
	UPDATE_MY_ACCOUNT: 'UPDATE_MY_ACCOUNT',
	UPDATE_MY_ACCOUNT_SUCCESS: 'UPDATE_MY_ACCOUNT_SUCCESS',
	UPDATE_MY_ACCOUNT_FAILURE: 'UPDATE_MY_ACCOUNT_FAILURE',

	// login
	GET_LOGIN: 'GET_LOGIN',
	GET_LOGIN_SUCCESS: 'GET_LOGIN_SUCCESS',
	GET_LOGIN_FAILURE: 'GET_LOGIN_FAILURE',
	GET_CURRENT_USER: 'GET_CURRENT_USER',
	POST_FORGOT_PASSWORD: 'POST_FORGOT_PASSWORD',
	POST_FORGOT_PASSWORD_SUCCESS: 'POST_FORGOT_PASSWORD_SUCCESS',
	POST_FORGOT_PASSWORD_FAILURE: 'POST_FORGOT_PASSWORD_FAILURE',
	POST_FORGOT_PASSWORD_RESET: 'POST_FORGOT_PASSWORD_RESET',

	POST_FORGOT_LOGIN: 'POST_FORGOT_LOGIN',
	POST_FORGOT_LOGIN_SUCCESS: 'POST_FORGOT_LOGIN_SUCCESS',
	POST_FORGOT_LOGIN_FAILURE: 'POST_FORGOT_LOGIN_FAILURE',
	POST_FORGOT_LOGIN_RESET: 'POST_FORGOT_LOGIN_RESET',

	GET_LOGOUT: 'GET_LOGOUT',
	GET_LOGOUT_SUCCESS: 'GET_LOGOUT_SUCCESS',
	GET_LOGOUT_FAILURE: 'GET_LOGOUT_FAILURE',

	// translation
	GET_TRANSLATIONS_BY_LANGUAGES: 'GET_TRANSLATIONS_BY_LANGUAGES',
	GET_TRANSLATIONS_BY_LANGUAGES_SUCCESS: 'GET_TRANSLATIONS_BY_LANGUAGES_SUCCESS',
	GET_TRANSLATIONS_BY_LANGUAGES_FAILURE: 'GET_TRANSLATIONS_BY_LANGUAGES_FAILURE',
	GET_LANGUAGES_ENABLED: 'GET_LANGUAGES_ENABLED',
	GET_LANGUAGES_ENABLED_SUCCESS: 'GET_LANGUAGES_ENABLED_SUCCESS',
	GET_LANGUAGES_ENABLED_FAILURE: 'GET_LANGUAGES_ENABLED_FAILURE',
	GET_TRANSLATIONS_PUBLIC_PAGE: 'GET_TRANSLATIONS_PUBLIC_PAGE',
	GET_TRANSLATIONS_PUBLIC_PAGE_SUCCESS: 'GET_TRANSLATIONS_PUBLIC_PAGE_SUCCESS',
	GET_TRANSLATIONS_PUBLIC_PAGE_FAILURE: 'GET_TRANSLATIONS_PUBLIC_PAGE_FAILURE',

	// users manager
	GET_ADMIN_USERS: 'GET_ADMIN_USERS',
	GET_ADMIN_USERS_SUCCESS: 'GET_ADMIN_USERS_SUCCESS',
	GET_ADMIN_USERS_FAILURE: 'GET_ADMIN_USERS_FAILURE',

	GET_USER_DETAIL: 'GET_USER_DETAIL',
	GET_USER_DETAIL_SUCCESS: 'GET_USER_DETAIL_SUCCESS',
	GET_USER_DETAIL_FAILURE: 'GET_USER_DETAIL_FAILURE',

	POST_USER_CREATE: 'POST_USER_CREATE',
	POST_USER_CREATE_SUCCESS: 'POST_USER_CREATE_SUCCESS',
	POST_USER_CREATE_FAILURE: 'POST_USER_CREATE_FAILURE',

	UPDATE_USER_DETAIL: 'UPDATE_USER_DETAIL',
	UPDATE_USER_DETAIL_SUCCESS: 'UPDATE_USER_DETAIL_SUCCESS',
	UPDATE_USER_DETAIL_FAILURE: 'UPDATE_USER_DETAIL_FAILURE',

	DELETE_ADMIN_USER: 'DELETE_ADMIN_USER',
	DELETE_ADMIN_USER_SUCCESS: 'DELETE_ADMIN_USER_SUCCESS',
	DELETE_ADMIN_USER_FAILURE: 'DELETE_ADMIN_USER_FAILURE',

	USER_DETAIL_RESET_PASSWORD: 'USER_DETAIL_RESET_PASSWORD',
	USER_DETAIL_RESET_PASSWORD_SUCCESS: 'USER_DETAIL_RESET_PASSWORD_SUCCESS',
	USER_DETAIL_RESET_PASSWORD_FAILURE: 'USER_DETAIL_RESET_PASSWORD_FAILURE',

	RESET_USER_DETAIL: 'RESET_USER_DETAIL',

	SET_USER_LOGIN: 'SET_USER_LOGIN',

	RESET_DATA_USERS_MANAGER: 'RESET_DATA_USERS_MANAGER',

	// Error
	CREATE_ERROR: 'CREATE_ERROR',
	CREATE_CRITICAL_ERROR: 'CREATE_CRITICAL_ERROR',
	CREATE_MAINTENANCE_MODE: 'CREATE_MAINTENANCE_MODE',

	// GLOBAL LOADER
	START_LOADING: 'START_LOADING',
	END_LOADING: 'END_LOADING',

	// Modal
	HYDRATE_MODAL: 'HYDRATE_MODAL',
	CLOSE_MODAL: 'CLOSE_MODAL',
	CLOSE_MODAL_REDIRECT: 'CLOSE_MODAL_REDIRECT',

	// Toast Success
	HYDRATE_TOAST: 'HYDRATE_TOAST',
	CLOSE_TOAST: 'CLOSE_TOAST',
	OPEN_NEXT: 'OPEN_NEXT',

	// ROLES MANAGER
	GET_ROLES: 'GET_ROLES',
	GET_ROLES_SUCCESS: 'GET_ROLES_SUCCESS',
	GET_ROLES_FAILURE: 'GET_ROLES_FAILURE',

	CREATE_ROLE: 'CREATE_ROLE',
	CREATE_ROLE_SUCCESS: 'CREATE_ROLE_SUCCESS',
	CREATE_ROLE_FAILURE: 'CREATE_ROLE_FAILURE',

	DELETE_ROLE: 'DELETE_ROLE',
	DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
	DELETE_ROLE_FAILURE: 'DELETE_ROLE_FAILURE',

	GET_ROLE_DETAIL: 'GET_ROLE_DETAIL',
	GET_ROLE_DETAIL_SUCCESS: 'GET_ROLE_DETAIL_SUCCESS',
	GET_ROLE_DETAIL_FAILURE: 'GET_ROLE_DETAIL_FAILURE',

	UPDATE_HEADER_ROLE: 'UPDATE_HEADER_ROLE',
	UPDATE_HEADER_ROLE_SUCCESS: 'UPDATE_HEADER_ROLE_SUCCESS',
	UPDATE_HEADER_ROLE_FAILURE: 'UPDATE_HEADER_ROLE_FAILURE',

	UPDATE_CONTENT_ROLE: 'UPDATE_CONTENT_ROLE',
	UPDATE_CONTENT_ROLE_SUCCESS: 'UPDATE_CONTENT_ROLE_SUCCESS',
	UPDATE_CONTENT_ROLE_FAILURE: 'UPDATE_CONTENT_ROLE_FAILURE',

	RESET_ROLE: 'RESET_ROLE',

	// TAGS MANAGER
	GET_TAGS: 'GET_TAGS',
	GET_TAGS_SUCCESS: 'GET_TAGS_SUCCESS',
	GET_TAGS_FAILURE: 'GET_TAGS_FAILURE',

	CREATE_TAG: 'CREATE_TAG',
	CREATE_TAG_SUCCESS: 'CREATE_TAG_SUCCESS',
	CREATE_TAG_FAILURE: 'CREATE_TAG_FAILURE',

	GET_TAG_DETAIL: 'GET_TAG_DETAIL',
	GET_TAG_DETAIL_SUCCESS: 'GET_TAG_DETAIL_SUCCESS',
	GET_TAG_DETAIL_FAILURE: 'GET_TAG_DETAIL_FAILURE',

	RESET_TAG: 'RESET_TAG',
	RESET_TAG_DETAIL: 'RESET_TAG_DETAIL',

	DELETE_TAG: 'DELETE_TAG',
	DELETE_TAG_SUCCESS: 'DELETE_TAG_SUCCESS',
	DELETE_TAG_FAILURE: 'DELETE_TAG_FAILURE',

	UPDATE_TAG_HEADER: 'UPDATE_TAG_HEADER',
	UPDATE_TAG_HEADER_SUCCESS: 'UPDATE_TAG_HEADER_SUCCESS',
	UPDATE_TAG_HEADER_FAILURE: 'UPDATE_TAG_HEADER_FAILURE',

	UPDATE_TAG_CONTENT: 'UPDATE_TAG_CONTENT',
	UPDATE_TAG_CONTENT_SUCCESS: 'UPDATE_TAG_CONTENT_SUCCESS',
	UPDATE_TAG_CONTENT_FAILURE: 'UPDATE_TAG_CONTENT_FAILURE',

	// PERIMETERS
	GET_PERIMETERS: 'GET_PERIMETERS',
	GET_PERIMETERS_SUCCESS: 'GET_PERIMETERS_SUCCESS',
	GET_PERIMETERS_FAILURE: 'GET_PERIMETERS_FAILURE',

	GET_PERIMETER: 'GET_PERIMETER',
	GET_PERIMETER_SUCCESS: 'GET_PERIMETER_SUCCESS',
	GET_PERIMETER_FAILURE: 'GET_PERIMETER_FAILURE',

	GET_KIOSKS_WITH_CRITERIA: 'GET_KIOSKS_WITH_CRITERIA',
	GET_KIOSKS_WITH_CRITERIA_SUCCESS: 'GET_KIOSKS_WITH_CRITERIA_SUCCESS',
	GET_KIOSKS_WITH_CRITERIA_FAILURE: 'GET_KIOSKS_WITH_CRITERIA_FAILURE',

	GET_LIST_TAGS: 'GET_LIST_TAGS',
	GET_LIST_TAGS_SUCCESS: 'GET_LIST_TAGS_SUCCESS',
	GET_LIST_TAGS_FAILURE: 'GET_LIST_TAGS_FAILURE',

	RESET_KIOSKS_SCOPE: 'RESET_KIOSKS_SCOPE',

	CREATE_PERIMETER: 'CREATE_PERIMETER',
	CREATE_PERIMETER_SUCCESS: 'CREATE_PERIMETER_SUCCESS',
	CREATE_PERIMETER_FAILURE: 'CREATE_PERIMETER_FAILURE',

	UPDATE_PERIMETER: 'UPDATE_PERIMETER',
	UPDATE_PERIMETER_SUCCESS: 'UPDATE_PERIMETER_SUCCESS',
	UPDATE_PERIMETER_FAILURE: 'UPDATE_PERIMETER_FAILURE',

	APPLY_PERIMETER: 'APPLY_PERIMETER',

	DELETE_PERIMETER: 'DELETE_PERIMETER',
	DELETE_PERIMETER_SUCCESS: 'DELETE_PERIMETER_SUCCESS',
	DELETE_PERIMETER_FAILURE: 'DELETE_PERIMETER_FAILURE',

	// SALES HISTORY
	GET_SALES_HISTORY: 'GET_SALES_HISTORY',
	GET_SALES_HISTORY_SUCCESS: 'GET_SALES_HISTORY_SUCCESS',
	GET_SALES_HISTORY_FAILURE: 'GET_SALES_HISTORY_FAILURE',

	SEND_MERCHANT_TICKET: 'SEND_MERCHANT_TICKET',
	SEND_MERCHANT_TICKET_SUCCESS: 'SEND_MERCHANT_TICKET_SUCCESS',
	SEND_MERCHANT_TICKET_FAILURE: 'SEND_MERCHANT_TICKET_FAILURE',

	SEND_GUEST_TICKET: 'SEND_GUEST_TICKET',
	SEND_GUEST_TICKET_SUCCESS: 'SEND_GUEST_TICKET_SUCCESS',
	SEND_GUEST_TICKET_FAILURE: 'SEND_GUEST_TICKET-FAILURE',

	SET_TRANSACTION_NUMBER: 'SET_TRANSACTION_NUMBER',
	RESET_TRANSACTION_NUMBER_CONSIGNATION: 'RESET_TRANSACTION_NUMBER_CONSIGNATION',

	RESET_TRANSACTION_ITEMS: 'RESET_TRANSACTION_ITEMS',

	SET_TELECOLLECT_ID: 'SET_TELECOLLECT_ID',

	SET_PROMOTION_NUMBER: 'SET_PROMOTION_NUMBER',

	// SCHEDULED PRICES
	GET_SCHEDULED_PRICES: 'GET_SCHEDULED_PRICES',
	GET_SCHEDULED_PRICES_SUCCESS: 'GET_SCHEDULED_PRICES_SUCCESS',
	GET_SCHEDULED_PRICES_FAILURE: 'GET_SCHEDULED_PRICES_FAILURE',

	GET_TRANSMISSION: 'GET_TRANSMISSION',
	GET_TRANSMISSION_SUCCESS: 'GET_TRANSMISSION_SUCCESS',
	GET_TRANSMISSION_FAILURE: 'GET_TRANSMISSION_FAILURE',

	GET_CAMPAIGN: 'GET_CAMPAIGN',
	GET_CAMPAIGN_SUCCESS: 'GET_CAMPAIGN_SUCCESS',
	GET_CAMPAIGN_FAILURE: 'GET_CAMPAIGN_FAILURE',

	POST_CHECK_CAMPAIGN: 'POST_CHECK_CAMPAIGN',
	POST_CHECK_CAMPAIGN_SUCCESS: 'POST_CHECK_CAMPAIGN_SUCCESS',
	POST_CHECK_CAMPAIGN_FAILURE: 'POST_CHECK_CAMPAIGN_FAILURE',

	CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
	CREATE_CAMPAIGN_SUCCESS: 'CREATE_CAMPAIGN_SUCCESS',
	CREATE_CAMPAIGN_FAILURE: 'CREATE_CAMPAIGN_FAILURE',

	RESET_CAMPAIGN: 'RESET_CAMPAIGN',
	RESET_CAMPAIGN_ITEMS: 'RESET_CAMPAIGN_ITEMS',

	UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
	UPDATE_CAMPAIGN_SUCCESS: 'UPDATE_CAMPAIGN_SUCCESS',
	UPDATE_CAMPAIGN_FAILURE: 'UPDATE_CAMPAIGN_FAILURE',

	CANCEL_CAMPAIGN: 'CANCEL_CAMPAIGN',
	CANCEL_CAMPAIGN_SUCCESS: 'CANCEL_CAMPAIGN_SUCCESS',
	CANCEL_CAMPAIGN_FAILURE: 'CANCEL_CAMPAIGN_FAILURE',

	RESET_SCHEDULED_PRICES_MANAGER_ITEMS: 'RESET_SCHEDULED_PRICES_MANAGER_ITEMS',

	GET_PRICE_CAMPAIGN_NESTED_LINES: 'GET_PRICE_CAMPAIGN_NESTED_LINES',
	GET_PRICE_CAMPAIGN_NESTED_LINES_SUCCESS: 'GET_PRICE_CAMPAIGN_NESTED_LINES_SUCCESS',
	GET_PRICE_CAMPAIGN_NESTED_LINES_FAILURE: 'GET_PRICE_CAMPAIGN_NESTED_LINES_FAILURE',

	///////// START PROMO //////////////////////////////

	GET_SCHEDULED_PROMO: 'GET_SCHEDULED_PROMO',
	GET_SCHEDULED_PROMO_SUCCESS: 'GET_SCHEDULED_PROMO_SUCCESS',
	GET_SCHEDULED_PROMO_FAILURE: 'GET_SCHEDULED_PROMO_FAILURE',

	GET_SCHEDULED_PROMO_UNIT: 'GET_SCHEDULED_PROMO_UNIT',
	GET_SCHEDULED_PROMO_UNIT_SUCCESS: 'GET_SCHEDULED_PROMO_UNIT_SUCCESS',
	GET_SCHEDULED_PROMO_UNIT_FAILURE: 'GET_SCHEDULED_PROMO_UNIT_FAILURE',

	GET_TRANSMISSION_PROMO: 'GET_TRANSMISSION_PROMO',
	GET_TRANSMISSION_PROMO_SUCCESS: 'GET_TRANSMISSION_PROMO_SUCCESS',
	GET_TRANSMISSION_PROMO_FAILURE: 'GET_TRANSMISSION_PROMO_FAILURE',

	GET_CAMPAIGN_PROMO: 'GET_CAMPAIGN_PROMO',
	GET_CAMPAIGN_PROMO_SUCCESS: 'GET_CAMPAIGN_PROMO_SUCCESS',
	GET_CAMPAIGN_PROMO_FAILURE: 'GET_CAMPAIGN_PROMO_FAILURE',

	POST_CHECK_CAMPAIGN_PROMO: 'POST_CHECK_CAMPAIGN_PROMO',
	POST_CHECK_CAMPAIGN_PROMO_SUCCESS: 'POST_CHECK_CAMPAIGN_PROMO_SUCCESS',
	POST_CHECK_CAMPAIGN_PROMO_FAILURE: 'POST_CHECK_CAMPAIGN_PROMO_FAILURE',

	CREATE_CAMPAIGN_PROMO: 'CREATE_CAMPAIGN_PROMO',
	CREATE_CAMPAIGN_PROMO_SUCCESS: 'CREATE_CAMPAIGN_PROMO_SUCCESS',
	CREATE_CAMPAIGN_PROMO_FAILURE: 'CREATE_CAMPAIGN_PROMO_FAILURE',

	RESET_CAMPAIGN_PROMO: 'RESET_CAMPAIGN_PROMO',
	RESET_CAMPAIGN_PROMO_ITEMS: 'RESET_CAMPAIGN_PROMO_ITEMS',

	UPDATE_CAMPAIGN_PROMO: 'UPDATE_CAMPAIGN_PROMO',
	UPDATE_CAMPAIGN_PROMO_SUCCESS: 'UPDATE_CAMPAIGN_PROMO_SUCCESS',
	UPDATE_CAMPAIGN_PROMO_FAILURE: 'UPDATE_CAMPAIGN_PROMO_FAILURE',

	CANCEL_CAMPAIGN_PROMO: 'CANCEL_CAMPAIGN_PROMO',
	CANCEL_CAMPAIGN_PROMO_SUCCESS: 'CANCEL_CAMPAIGN_PROMO_SUCCESS',
	CANCEL_CAMPAIGN_PROMO_FAILURE: 'CANCEL_CAMPAIGN_PROMO_FAILURE',

	GET_PROMO_CAMPAIGN_NESTED_LINES: 'GET_PROMO_CAMPAIGN_NESTED_LINES',
	GET_PROMO_CAMPAIGN_NESTED_LINES_SUCCESS: 'GET_PROMO_CAMPAIGN_NESTED_LINES_SUCCESS',
	GET_PROMO_CAMPAIGN_NESTED_LINES_FAILURE: 'GET_PROMO_CAMPAIGN_NESTED_LINES_FAILURE',

	RESET_SCHEDULED_PROMO_MANAGER_ITEMS: 'RESET_SCHEDULED_PROMO_MANAGER_ITEMS',
	///////// END PROMO //////////////////////////////

	// KIOSK PRICES MANAGER
	POST_KIOSK_PRICES_MANAGER: 'POST_KIOSK_PRICES_MANAGER',
	POST_KIOSK_PRICES_MANAGER_SUCCESS: 'POST_KIOSK_PRICES_MANAGER_SUCCESS',
	POST_KIOSK_PRICES_MANAGER_FAILURE: 'POST_KIOSK_PRICES_MANAGER_FAILURE',

	// PRICE MANAGER BY ARTICLE
	GET_PRICES_ARTICLE: 'GET_PRICES_ARTICLE',
	GET_PRICES_ARTICLE_SUCCESS: 'GET_PRICES_ARTICLE_SUCCESS',
	GET_PRICES_ARTICLE_FAILURE: 'GET_PRICES_ARTICLE_FAILURE',

	// DATEPICKER
	UPDATE_DATE: 'UPDATE_DATE',

	//////////////////////////////////////
	// START RECAP STOCK
	POST_RECAP_STOCK_REQUEST: 'POST_RECAP_STOCK_REQUEST',
	POST_RECAP_STOCK_SUCCESS: 'POST_RECAP_STOCK_SUCCESS',
	POST_RECAP_STOCK_FAILURE: 'POST_RECAP_STOCK_FAILURE',

	PUT_RECAP_STOCK_REQUEST: 'PUT_RECAP_STOCK_REQUEST',
	PUT_RECAP_STOCK_SUCCESS: 'PUT_RECAP_STOCK_SUCCESS',
	PUT_RECAP_STOCK_FAILURE: 'PUT_RECAP_STOCK_FAILURE',

	POST_RECAP_STOCK_FROM_REDIRECT: 'POST_RECAP_STOCK_FROM_REDIRECT',
	POST_RECAP_STOCK_FROM_REDIRECT_SUCCESS: 'POST_RECAP_STOCK_FROM_REDIRECT_SUCCESS',
	POST_RECAP_STOCK_FROM_REDIRECT_FAILURE: 'POST_RECAP_STOCK_FROM_REDIRECT_FAILURE',

	RESET_RECAP_STOCK_FILTERS_INFOS: 'RESET_RECAP_STOCK_FILTERS_INFOS',
	RESET_RECAP_STOCK: 'RESET_RECAP_STOCK',
	// AND RECAP STOCK
	//////////////////////////////////////

	// CONSIGNATION

	POST_CONSIGNATION: 'POST_CONSIGNATION',
	POST_CONSIGNATION_SUCCESS: 'POST_CONSIGNATION_SUCCESS',
	POST_CONSIGNATION_FAILURE: 'POST_CONSIGNATION_FAILURE',

	RESET_CONSIGNATION: 'RESET_CONSIGNATION',

	UPDATE_CUSTOMER_INFOS: 'UPDATE_CUSTOMER_INFOS',
	UPDATE_CUSTOMER_INFOS_SUCCESS: 'UPDATE_CUSTOMER_INFOS_SUCCESS',
	UPDATE_CUSTOMER_INFOS_FAILURE: 'UPDATE_CUSTOMER_INFOS_FAILURE',

	SEND_CONSIGNEMENT_CONTRACT: 'SEND_CONSIGNEMENT_CONTRACT',
	SEND_CONSIGNEMENT_CONTRACT_SUCCESS: 'SEND_CONSIGNEMENT_CONTRACT_SUCCESS',
	SEND_CONSIGNEMENT_CONTRACT_FAILURE: 'SEND_CONSIGNEMENT_CONTRACT_FAILURE',

	GET_TRANSACTION_NUMBER: 'GET_TRANSACTION_NUMBER',
	RESET_TRANSACTION_NUMBER: 'RESET_TRANSACTION_NUMBER',

	VIEW_CONSIGNEMENT_CONTRACT: 'VIEW_CONSIGNEMENT_CONTRACT',
	VIEW_CONSIGNEMENT_CONTRACT_SUCCESS: 'VIEW_CONSIGNEMENT_CONTRACT_SUCCESS',
	VIEW_CONSIGNEMENT_CONTRACT_FAILURE: 'VIEW_CONSIGNEMENT_CONTRACT_FAILURE',

	// MARKETING

	POST_MARKETING: 'POST_MARKETING',
	POST_MARKETING_SUCCESS: 'POST_MARKETING_SUCCESS',
	POST_MARKETING_FAILURE: 'POST_MARKETING_FAILURE',

	RESET_MARKETING: 'RESET_MARKETING',

	// TELECOLLECTS
	GET_TELECOLLECTS: 'GET_TELECOLLECTS',
	GET_TELECOLLECTS_SUCCESS: 'GET_TELECOLLECTS_SUCCESS',
	GET_TELECOLLECTS_FAILURE: 'GET_TELECOLLECTS_FAILURE',

	GET_TELECOLLECT_HEADER: 'GET_TELECOLLECT_HEADER',
	GET_TELECOLLECT_HEADER_SUCCESS: 'GET_TELECOLLECT_HEADER_SUCCESS',
	GET_TELECOLLECT_HEADER_FAILURE: 'GET_TELECOLLECT_HEADER_FAILURE',

	GET_TELECOLLECT_DETAIL_ITEMS: 'GET_TELECOLLECT_DETAIL_ITEMS',
	GET_TELECOLLECT_DETAIL_ITEMS_SUCCESS: 'GET_TELECOLLECT_DETAIL_ITEMS_SUCCESS',
	GET_TELECOLLECT_DETAIL_ITEMS_FAILURE: 'GET_TELECOLLECT_DETAIL_ITEMS_FAILURE',

	GET_TELECOLLECT_DETAIL_SALE: 'GET_TELECOLLECT_DETAIL_SALE',
	GET_TELECOLLECT_DETAIL_SALE_SUCCESS: 'GET_TELECOLLECT_DETAIL_SALE_SUCCESS',
	GET_TELECOLLECT_DETAIL_SALE_FAILURE: 'GET_TELECOLLECT_DETAIL_SALE_FAILURE',

	SET_TELECOLLECT_COMPARISON: 'SET_TELECOLLECT_COMPARISON',
	SET_TELECOLLECT_COMPARISON_SUCCESS: 'SET_TELECOLLECT_COMPARISON_SUCCESS',
	SET_TELECOLLECT_COMPARISON_FAILURE: 'SET_TELECOLLECT_COMPARISON_FAILURE',

	RESET_TELECOLLECT_ITEMS: 'RESET_TELECOLLECT_ITEMS',

	GET_TELECOLLECT_TICKET: 'GET_TELECOLLECT_TICKET',
	GET_TELECOLLECT_TICKET_SUCCESS: 'GET_TELECOLLECT_TICKET_SUCCESS',
	GET_TELECOLLECT_TICKET_FAILURE: 'GET_TELECOLLECT_TICKET_FAILURE',

	///////////////////////////////////////////////////////
	/////////////////////LOG //////////////////////////////
	//////////////////////////////////////////////////////

	//////////////////////////Log User///////////////////

	POST_LOG_USERS: 'POST_LOG_USERS',
	POST_LOG_USERS_SUCCESS: 'POST_LOG_USERS_SUCCESS',
	POST_LOG_USERS_FAILURE: 'POST_LOG_USERS_FAILURE',

	GET_USER_LOGIN: 'GET_USER_LOGIN',

	RESET_LOG_USERS: 'RESET_LOG_USERS',

	/////////////////////////////////////////////////////

	//////////////////////////Log kiosk///////////////////

	POST_LOG_KIOSK: 'POST_LOG_KIOSK',
	POST_LOG_KIOSK_SUCCESS: 'POST_LOG_KIOSK_SUCCESS',
	POST_LOG_KIOSK_FAILURE: 'POST_LOG_KIOSK_FAILURE',

	RESET_LOG_KIOSK: 'RESET_LOG_KIOSK',

	/////////////////////////////////////////////////////

	//////////////////////////Log Synchro///////////////////

	POST_LOG_SYNCHRO: 'POST_LOG_SYNCHRO',
	POST_LOG_SYNCHRO_SUCCESS: 'POST_LOG_SYNCHRO_SUCCESS',
	POST_LOG_SYNCHRO_FAILURE: 'POST_LOG_SYNCHRO_FAILURE',

	RESET_LOG_SYNCHRO_ITEMS: 'RESET_LOG_SYNCHRO_ITEMS',
	RESET_LOG_SYNCHRO: 'RESET_LOG_SYNCHRO',

	/////////////////////////////////////"////////////////

	//////////////////////////Log Extranet///////////////////

	POST_LOG_EXTRANET: 'POST_LOG_EXTRANET',
	POST_LOG_EXTRANET_SUCCESS: 'POST_LOG_EXTRANET_SUCCESS',
	POST_LOG_EXTRANET_FAILURE: 'POST_LOG_EXTRANET_FAILURE',

	RESET_LOG_EXTRANET: 'RESET_LOG_EXTRANET',

	/////////////////////////////////////////////////////

	// RGPD

	POST_SEARCH_CUTOMER: 'POST_SEARCH_CUTOMER',
	POST_SEARCH_CUTOMER_SUCCESS: 'POST_SEARCH_CUTOMER_SUCCESS',
	POST_SEARCH_CUTOMER_FAILURE: 'POST_SEARCH_CUTOMER_FAILURE',

	POST_CUSTOMER_DATA: 'POST_CUSTOMER_DATA',
	POST_CUSTOMER_DATA_SUCCESS: 'POST_CUSTOMER_DATA_SUCCESS',
	POST_CUSTOMER_DATA_FAILURE: 'POST_CUSTOMER_DATA_FAILURE',

	POST_ANONYMISE_DATA: 'POST_ANONYMISE_DATA',
	POST_ANONYMISE_DATA_SUCCESS: 'POST_ANONYMISE_DATA_SUCCESS',
	POST_ANONYMISE_DATA_FAILURE: 'POST_ANONYMISE_DATA_FAILURE',

	RESET_DATA_RGPD: 'RESET_DATA_RGPD',

	RESET_UNKNOWN_MAIL_ERROR: 'RESET_UNKNOWN_MAIL_ERROR',

	// Sales history by codes

	GET_HISTO_CODE: 'GET_HISTO_CODE',
	GET_HISTO_CODE_SUCCESS: 'GET_HISTO_CODE_SUCCESS',
	GET_HISTO_CODE_FAILURE: 'GET_HISTO_CODE_FAILURE',

	POST_DISPLAY_TICKET: 'POST_DISPLAY_TICKET',
	POST_DISPLAY_TICKET_SUCCESS: 'POST_DISPLAY_TICKET_SUCCESS',
	POST_DISPLAY_TICKET_FAILURE: 'POST_DISPLAY_TICKET_FAILURE',

	POST_REVIEW_TICKET: 'POST_REVIEW_TICKET',
	POST_REVIEW_TICKET_SUCCESS: 'POST_REVIEW_TICKET_SUCCESS',
	POST_REVIEW_TICKET_FAILURE: 'POST_REVIEW_TICKET_FAILURE',

	POST_SMS_TICKET: 'POST_SMS_TICKET',
	POST_SMS_TICKET_SUCCESS: 'POST_SMS_TICKET_SUCCESS',
	POST_SMS_TICKET_FAILURE: 'POST_SMS_TICKET_FAILURE',

	POST_DELETE_SALE_CODE: 'POST_DELETE_SALE_CODE',
	POST_DELETE_SALE_CODE_SUCCESS: 'POST_DELETE_SALE_CODE_SUCCESS',
	POST_DELETE_SALE_CODE_FAILURE: 'POST_DELETE_SALE_CODE_FAILURE',

	POST_CANCEL_SALE_CODE: 'POST_CANCEL_SALE_CODE',
	POST_CANCEL_SALE_CODE_SUCCESS: 'POST_CANCEL_SALE_CODE_SUCCESS',
	POST_CANCEL_SALE_CODE_FAILURE: 'POST_CANCEL_SALE_CODE_FAILURE',

	POST_RENEW_CODE: 'POST_RENEW_CODE',
	POST_RENEW_CODE_SUCCESS: 'POST_RENEW_CODE_SUCCESS',
	POST_RENEW_CODE_FAILURE: 'POST_RENEW_CODE_FAILURE',

	GET_TRANSACTION_ID: 'GET_TRANSACTION_ID',

	RESET_HISTO_CODE_ITEMS: 'RESET_HISTO_CODE_ITEMS',

	// SALES BY ARTICLE HISTORY
	GET_SALES_BY_ARTICLE_HISTORY: 'GET_SALES_BY_ARTICLE_HISTORY',
	GET_SALES_BY_ARTICLE_HISTORY_SUCCESS: 'GET_SALES_BY_ARTICLE_HISTORY_SUCCESS',
	GET_SALES_BY_ARTICLE_HISTORY_FAILURE: 'GET_SALES_BY_ARTICLE_HISTORY_FAILURE',

	RESET_SALES_BY_ARTICLE_ITEMS: 'RESET_SALES_BY_ARTICLE_ITEMS',

	SET_TRANSACTION_BY_ARTICLE_NUMBER: 'SET_TRANSACTION_BY_ARTICLE_NUMBER',

	SET_PROMOTION_BY_ARTICLE_NUMBER: 'SET_PROMOTION_BY_ARTICLE_NUMBER',

	// Distribution group repository

	POST_DISTRIBUTION_GROUP: 'POST_DISTRIBUTION_GROUP',
	POST_DISTRIBUTION_GROUP_SUCCESS: 'POST_DISTRIBUTION_GROUP_SUCCESS',
	POST_DISTRIBUTION_GROUP_FAILURE: 'POST_DISTRIBUTION_GROUP_FAILURE',

	POST_ACTIVE_ITEM: 'POST_ACTIVE_ITEM',
	POST_ACTIVE_ITEM_SUCCESS: 'POST_ACTIVE_ITEM_SUCCESS',
	POST_ACTIVE_ITEM_FAILURE: 'POST_ACTIVE_ITEM_FAILURE',

	POST_DELETE_ITEM: 'POST_DELETE_ITEM',
	POST_DELETE_ITEM_SUCCESS: 'POST_DELETE_ITEM_SUCCESS',
	POST_DELETE_ITEM_FAILURE: 'POST_DELETE_ITEM_FAILURE',

	GET_ITEM_DETAIL: 'GET_ITEM_DETAIL',
	GET_ITEM_DETAIL_SUCCESS: 'GET_ITEM_DETAIL_SUCCESS',
	GET_ITEM_DETAIL_FAILURE: 'GET_ITEM_DETAIL_FAILURE',

	SET_ITEM_ID: 'SET_ITEM_ID',

	RESET_DISTRIBUTION_GROUP: 'RESET_DISTRIBUTION_GROUP',

	// ARTICLE MANAGER
	GET_ARTICLE_AVAILABLE_LISTS: 'GET_ARTICLE_AVAILABLE_LISTS',
	GET_ARTICLE_AVAILABLE_LISTS_SUCCESS: 'GET_ARTICLE_AVAILABLE_LISTS_SUCCESS',
	GET_ARTICLE_AVAILABLE_LISTS_FAILURE: 'GET_ARTICLE_AVAILABLE_LISTS_FAILURE',

	CREATE_ARTICLE: 'CREATE_ARTICLE',
	CREATE_ARTICLE_SUCCESS: 'CREATE_ARTICLE_SUCCESS',
	CREATE_ARTICLE_FAILURE: 'CREATE_ARTICLE_FAILURE',

	GET_ARTICLE_ITEM: 'GET_ARTICLE_ITEM',
	GET_ARTICLE_ITEM_SUCCESS: 'GET_ARTICLE_ITEM_SUCCESS',
	GET_ARTICLE_ITEM_FAILURE: 'GET_ARTICLE_ITEM_FAILURE',

	UPDATE_ARTICLE: 'UPDATE_ARTICLE',
	UPDATE_ARTICLE_SUCCESS: 'UPDATE_ARTICLE_SUCCESS',
	UPDATE_ARTICLE_FAILURE: 'UPDATE_ARTICLE_FAILURE',

	DELETE_ARTICLE: 'DELETE_ARTICLE',
	DELETE_ARTICLE_SUCCESS: 'DELETE_ARTICLE_SUCCESS',
	DELETE_ARTICLE_FAILURE: 'DELETE_ARTICLE_FAILURE',

	POST_DEACTIVATE_REF_ITEM: 'POST_DEACTIVATE_REF_ITEM',
	POST_DEACTIVATE_REF_ITEM_SUCCESS: 'POST_DEACTIVATE_REF_ITEM_SUCCESS',
	POST_DEACTIVATE_REF_ITEM_FAILURE: 'POST_DEACTIVATE_REF_ITEM_FAILURE',

	// BIND CATALOG

	POST_BIND_CATALOG: 'POST_BIND_CATALOG',
	POST_BIND_CATALOG_SUCCESS: 'POST_BIND_CATALOG_SUCCESS',
	POST_BIND_CATALOG_FAILURE: 'POST_BIND_CATALOG_FAILURE',

	PUT_LINK_CATALOG_ITEM: 'PUT_LINK_CATALOG_ITEM',
	PUT_LINK_CATALOG_ITEM_SUCCESS: 'PUT_LINK_CATALOG_ITEM_SUCCESS',
	PUT_LINK_CATALOG_ITEM_FAILURE: 'PUT_LINK_CATALOG_ITEM_FAILURE',

	PUT_UNLINK_CATALOG_ITEM: 'PUT_UNLINK_CATALOG_ITEM',
	PUT_UNLINK_CATALOG_ITEM_SUCCESS: 'PUT_UNLINK_CATALOG_ITEM_SUCCESS',
	PUT_UNLINK_CATALOG_ITEM_FAILURE: 'PUT_UNLINK_CATALOG_ITEM_FAILURE',

	RESET_DATA_ARTICLE: 'RESET_DATA_ARTICLE',

	///////////// START MODAL TOOLTIP HELP /////////////
	OPEN_TOOLTIP_HELP: 'OPEN_TOOLTIP_HELP',
	CLOSE_TOOLTIP_HELP: 'CLOSE_TOOLTIP_HELP',
	///////////// CLOSE MODAL TOOLTIP HELP /////////////

	// COMPANIES MANAGER
	GET_COMPANIES: 'GET_COMPANIES',
	GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
	GET_COMPANIES_FAILURE: 'GET_COMPANIES_FAILURE',

	SET_USER_COMPANY_ID: 'SET_USER_COMPANY_ID',

	SET_STATE_COMPANY: 'SET_STATE_COMPANY',
	SET_STATE_COMPANY_SUCCESS: 'SET_STATE_COMPANY_SUCCESS',
	SET_STATE_COMPANY_FAILURE: 'SET_STATE_COMPANY_FAILURE',

	GET_COMPANY_AVAILABLE_LISTS: 'GET_COMPANY_AVAILABLE_LISTS',
	GET_COMPANY_AVAILABLE_LISTS_SUCCESS: 'GET_COMPANY_AVAILABLE_LISTS_SUCCESS',
	GET_COMPANY_AVAILABLE_LISTS_FAILURE: 'GET_COMPANY_AVAILABLE_LISTS_FAILURE',

	CREATE_COMPANY: 'CREATE_COMPANY',
	CREATE_COMPANY_SUCCESS: 'CREATE_COMPANY_SUCCESS',
	CREATE_COMPANY_FAILURE: 'CREATE_COMPANY_FAILURE',

	GET_COMPANY_DATA: 'GET_COMPANY_DATA',
	GET_COMPANY_DATA_SUCCESS: 'GET_COMPANY_DATA_SUCCESS',
	GET_COMPANY_DATA_FAILURE: 'GET_COMPANY_DATA_FAILURE',

	UPDATE_COMPANY: 'UPDATE_COMPANY',
	UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
	UPDATE_COMPANY_FAILURE: 'UPDATE_COMPANY_FAILURE',

	RESET_DATA_COMPANY: 'RESET_DATA_COMPANY',

	CHECK_DISTRIBUTION_GROUP_DISABLING: 'CHECK_DISTRIBUTION_GROUP_DISABLING',
	CHECK_DISTRIBUTION_GROUP_DISABLING_SUCCESS: 'CHECK_DISTRIBUTION_GROUP_DISABLING_SUCCESS',
	CHECK_DISTRIBUTION_GROUP_DISABLING_FAILURE: 'CHECK_DISTRIBUTION_GROUP_DISABLING_FAILURE',

	CHECK_DISTRIBUTION_DISABLING: 'CHECK_DISTRIBUTION_DISABLING',
	CHECK_DISTRIBUTION_DISABLING_SUCCESS: 'CHECK_DISTRIBUTION_DISABLING_SUCCESS',
	CHECK_DISTRIBUTION_DISABLING_FAILURE: 'CHECK_DISTRIBUTION_DISABLING_FAILURE',

	DELETE_TECH_SUPPORT: 'DELETE_TECH_SUPPORT',
	DELETE_TECH_SUPPORT_SUCCESS: 'DELETE_TECH_SUPPORT_SUCCESS',
	DELETE_TECH_SUPPORT_FAILURE: 'DELETE_TECH_SUPPORT_FAILURE',

	PUT_SMS_REFILL: 'PUT_SMS_REFILL',
	PUT_SMS_REFILL_SUCCESS: 'PUT_SMS_REFILL_SUCCESS',
	PUT_SMS_REFILL_FAILURE: 'PUT_SMS_REFILL_FAILURE',

	PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP: 'PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP',
	PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_SUCCESS: 'PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_SUCCESS',
	PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_FAILURE: 'PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP_FAILURE',

	PUT_DELETE_COMPANY_SUBGROUP_LINK: 'PUT_DELETE_COMPANY_SUBGROUP_LINK',
	PUT_DELETE_COMPANY_SUBGROUP_LINK_SUCCESS: 'PUT_DELETE_COMPANY_SUBGROUP_LINK_SUCCESS',
	PUT_DELETE_COMPANY_SUBGROUP_LINK_FAILURE: 'PUT_DELETE_COMPANY_SUBGROUP_LINK_FAILURE',

	SET_OWNER: 'SET_OWNER',

	// TRANSLATIONS MANAGER
	GET_LIST_TRANSLATIONS: 'GET_LIST_TRANSLATIONS',
	GET_LIST_TRANSLATIONS_SUCCESS: 'GET_LIST_TRANSLATIONS_SUCCESS',
	GET_LIST_TRANSLATIONS_FAILURE: 'GET_LIST_TRANSLATIONS_FAILURE',

	SET_TRANSLATION: 'SET_TRANSLATION',
	SET_TRANSLATION_SUCCESS: 'SET_TRANSLATION_SUCCESS',
	SET_TRANSLATION_FAILURE: 'SET_TRANSLATION_FAILURE',

	// EXPORT DATA

	POST_EXPORT_DATAS: 'POST_EXPORT_DATAS',
	POST_EXPORT_DATAS_SUCCESS: 'POST_EXPORT_DATAS_SUCCESS',
	POST_EXPORT_DATAS_FAILURE: 'POST_EXPORT_DATAS_FAILURE',

	// USER PREFERENCES
	GET_USER_PREFERENCES: 'GET_USER_PREFERENCES',
	GET_USER_PREFERENCES_SUCCESS: 'GET_USER_PREFERENCES_SUCCESS',
	GET_USER_PREFERENCES_FAILURE: 'GET_USER_PREFERENCES_FAILURE',

	SET_USER_PREFERENCE: 'SET_USER_PREFERENCE',
	SET_USER_PREFERENCE_SUCCESS: 'SET_USER_PREFERENCE_SUCCESS',
	SET_USER_PREFERENCE_FAILURE: 'SET_USER_PREFERENCE_FAILURE',

	SET_IS_ACTIVED_PREFERENCE: 'SET_IS_ACTIVED_PREFERENCE',

	// NOTIFICATIONS

	GET_LOGS_NOTIFICATION: 'GET_LOGS_NOTIFICATION',
	GET_LOGS_NOTIFICATION_SUCCESS: 'GET_LOGS_NOTIFICATION_SUCCESS',
	GET_LOGS_NOTIFICATION_FAILURE: 'GET_LOGS_NOTIFICATION_FAILURE',

	UPDATE_RESOLVED_LOG: 'UPDATE_RESOLVED_LOG',
	UPDATE_RESOLVED_LOG_SUCCESS: 'UPDATE_RESOLVED_LOG_SUCCESS',
	UPDATE_RESOLVED_LOG_FAILURE: 'UPDATE_RESOLVED_LOG_FAILURE',

	UPDATE_REMOTED_LOG: 'UPDATE_REMOTED_LOG',
	UPDATE_REMOTED_LOG_SUCCESS: 'UPDATE_REMOTED_LOG_SUCCESS',
	UPDATE_REMOTED_LOG_FAILURE: 'UPDATE_REMOTED_LOG_FAILURE',

	CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
	CLOSE_NOTIFICATION_SUCCESS: 'CLOSE_NOTIFICATION_SUCCESS',
	CLOSE_NOTIFICATION_FAILURE: 'CLOSE_NOTIFICATION_FAILURE',

	CLOSE_ALL_NOTIFICATION: 'CLOSE_ALL_NOTIFICATION',
	CLOSE_ALL_NOTIFICATION_SUCCESS: 'CLOSE_ALL_NOTIFICATION_SUCCESS',
	CLOSE_ALL_NOTIFICATION_FAILURE: 'CLOSE_ALL_NOTIFICATION_FAILURE',

	REPORT_NOTIFICATION: 'REPORT_NOTIFICATION',
	REPORT_NOTIFICATION_SUCCESS: 'REPORT_NOTIFICATION_SUCCESS',
	REPORT_NOTIFICATION_FAILURE: 'REPORT_NOTIFICATION_FAILURE',

	CLOSE_NOTIFICATIONS_POLLING: 'CLOSE_NOTIFICATIONS_POLLING',

	// ARTICLE LIFE MANAGER
	RESET_DATA_ARTICLE_LIFE: 'RESET_DATA_ARTICLE_LIFE',

	GET_ARTICLE_LIFE_TIMELINE: 'GET_ARTICLE_LIFE_TIMELINE',
	GET_ARTICLE_LIFE_TIMELINE_SUCCESS: 'GET_ARTICLE_LIFE_TIMELINE_SUCCESS',
	GET_ARTICLE_LIFE_TIMELINE_FAILURE: 'GET_ARTICLE_LIFE_TIMELINE_FAILURE',

	GET_ARTICLE_LIFE_TIMELINE_PHASES: 'GET_ARTICLE_LIFE_TIMELINE_PHASES',
	GET_ARTICLE_LIFE_TIMELINE_PHASES_SUCCESS: 'GET_ARTICLE_LIFE_TIMELINE_PHASES_SUCCESS',
	GET_ARTICLE_LIFE_TIMELINE_PHASES_FAILURE: 'GET_ARTICLE_LIFE_TIMELINE_PHASES_FAILURE',

	GET_HEADER_ACTION_ARTICLE_LIFE: 'GET_HEADER_ACTION_ARTICLE_LIFE',
	GET_HEADER_ACTION_ARTICLE_LIFE_SUCCESS: 'GET_HEADER_ACTION_ARTICLE_LIFE_SUCCESS',
	GET_HEADER_ACTION_ARTICLE_LIFE_FAILURE: 'GET_HEADER_ACTION_ARTICLE_LIFE_FAILURE',

	POST_DELETED_ITEM: 'POST_DELETED_ITEM',
	POST_DELETED_ITEM_SUCCESS: 'POST_DELETED_ITEM_SUCCESS',
	POST_DELETED_ITEM_FAILURE: 'POST_DELETED_ITEM_FAILURE',

	POST_UNACTIVE_ITEM: 'POST_UNACTIVE_ITEM',
	POST_UNACTIVE_ITEM_SUCCESS: 'POST_UNACTIVE_ITEM_SUCCESS',
	POST_UNACTIVE_ITEM_FAILURE: 'POST_UNACTIVE_ITEM_FAILURE',

	POST_DELETE_STOP_DEPOSIT: 'POST_DELETE_STOP_DEPOSIT',
	POST_DELETE_STOP_DEPOSIT_SUCCESS: 'POST_DELETE_STOP_DEPOSIT_SUCCESS',
	POST_DELETE_STOP_DEPOSIT_FAILURE: 'POST_DELETE_STOP_DEPOSIT_FAILURE',

	POST_ACTIVED_ITEM: 'POST_ACTIVED_ITEM',
	POST_ACTIVED_ITEM_SUCCESS: 'POST_ACTIVED_ITEM_SUCCESS',
	POST_ACTIVED_ITEM_FAILURE: 'POST_ACTIVED_ITEM_FAILURE',

	UPDATE_START_DEPOSIT_ACTION: 'UPDATE_START_DEPOSIT_ACTION',
	UPDATE_START_DEPOSIT_ACTION_SUCCESS: 'UPDATE_START_DEPOSIT_ACTION_SUCCESS',
	UPDATE_START_DEPOSIT_ACTION_FAILURE: 'UPDATE_START_DEPOSIT_ACTION_FAILURE',

	UPDATE_STOP_DEPOSIT_ACTION: 'UPDATE_STOP_DEPOSIT_ACTION',
	UPDATE_STOP_DEPOSIT_ACTION_SUCCESS: 'UPDATE_STOP_DEPOSIT_ACTION_SUCCESS',
	UPDATE_STOP_DEPOSIT_ACTION_FAILURE: 'UPDATE_STOP_DEPOSIT_ACTION_FAILURE',

	POST_ADD_STOP_DEPOSIT: 'POST_ADD_STOP_DEPOSIT',
	POST_ADD_STOP_DEPOSIT_SUCCESS: 'POST_ADD_STOP_DEPOSIT_SUCCESS',
	POST_ADD_STOP_DEPOSIT_FAILURE: 'POST_ADD_STOP_DEPOSIT_FAILURE',

	POST_DELETE_ADD_START_WITH_DEPOSIT: 'POST_DELETE_ADD_START_WITH_DEPOSIT',
	POST_DELETE_ADD_START_WITH_DEPOSIT_SUCCESS: 'POST_DELETE_ADD_START_WITH_DEPOSIT_SUCCESS',
	POST_DELETE_ADD_START_WITH_DEPOSIT_FAILURE: 'POST_DELETE_ADD_START_WITH_DEPOSIT_FAILURE',

	POST_DELETE_SCHEDULED_ACTIVATE: 'POST_DELETE_SCHEDULED_ACTIVATE',
	POST_DELETE_SCHEDULED_ACTIVATE_SUCCESS: 'POST_DELETE_SCHEDULED_ACTIVATE_SUCCESS',
	POST_DELETE_SCHEDULED_ACTIVATE_FAILURE: 'POST_DELETE_SCHEDULED_ACTIVATE_FAILURE',

	POST_ADD_START_WITH_DEPOSIT: 'POST_ADD_START_WITH_DEPOSIT',
	POST_ADD_START_WITH_DEPOSIT_SUCCESS: 'POST_ADD_START_WITH_DEPOSIT_SUCCESS',
	POST_ADD_START_WITH_DEPOSIT_FAILURE: 'POST_ADD_START_WITH_DEPOSIT_FAILURE',

	POST_SCHEDULE_ACTIVATE_ACTION: 'POST_SCHEDULE_ACTIVATE_ACTION',
	POST_SCHEDULE_ACTIVATE_ACTION_SUCCESS: 'POST_SCHEDULE_ACTIVATE_ACTION_SUCCESS',
	POST_SCHEDULE_ACTIVATE_ACTION_FAILURE: 'POST_SCHEDULE_ACTIVATE_ACTION_FAILURE',

	UPDATE_SCHEDULED_ACTIVATE_ACTION: 'UPDATE_SCHEDULED_ACTIVATE_ACTION',
	UPDATE_SCHEDULED_ACTIVATE_ACTION_SUCCESS: 'UPDATE_SCHEDULED_ACTIVATE_ACTION_SUCCESS',
	UPDATE_SCHEDULED_ACTIVATE_ACTION_FAILURE: 'UPDATE_SCHEDULED_ACTIVATE_ACTION_FAILURE',

	POST_SCHEDULED_DEACTIVATE_ACTION: 'POST_SCHEDULED_DEACTIVATE_ACTION',
	POST_SCHEDULED_DEACTIVATE_ACTION_SUCCESS: 'POST_SCHEDULED_DEACTIVATE_ACTION_SUCCESS',
	POST_SCHEDULED_DEACTIVATE_ACTION_FAILURE: 'POST_SCHEDULED_DEACTIVATE_ACTION_FAILURE',

	POST_CANCEL_DEACTIVATE_ACTION: 'POST_CANCEL_DEACTIVATE_ACTION',
	POST_CANCEL_DEACTIVATE_ACTION_SUCCESS: 'POST_CANCEL_DEACTIVATE_ACTION_SUCCESS',
	POST_CANCEL_DEACTIVATE_ACTION_FAILURE: 'POST_CANCEL_DEACTIVATE_ACTION_FAILURE',

	POST_DELETE_DESACTIVATION_SCHEDULED: 'POST_DELETE_DESACTIVATION_SCHEDULED',
	POST_DELETE_DESACTIVATION_SCHEDULED_SUCCESS: 'POST_DELETE_DESACTIVATION_SCHEDULED_SUCCESS',
	POST_DELETE_DESACTIVATION_SCHEDULED_FAILURE: 'POST_DELETE_DESACTIVATION_SCHEDULED_FAILURE',

	POST_DELETE_STOP_WITH_RESTOCK: 'POST_DELETE_STOP_WITH_RESTOCK',
	POST_DELETE_STOP_WITH_RESTOCK_SUCCESS: 'POST_DELETE_STOP_WITH_RESTOCK_SUCCESS',
	POST_DELETE_STOP_WITH_RESTOCK_FAILURE: 'POST_DELETE_STOP_WITH_RESTOCK_FAILURE',

	POST_ADD_STOP_WITH_RESTOCK: 'POST_ADD_STOP_WITH_RESTOCK',
	POST_ADD_STOP_WITH_RESTOCK_SUCCESS: 'POST_ADD_STOP_WITH_RESTOCK_SUCCESS',
	POST_ADD_STOP_WITH_RESTOCK_FAILURE: 'POST_ADD_STOP_WITH_RESTOCK_FAILURE',

	POST_EDIT_STOP_WITH_RESTOCK: 'POST_EDIT_STOP_WITH_RESTOCK',
	POST_EDIT_STOP_WITH_RESTOCK_SUCCESS: 'POST_EDIT_STOP_WITH_RESTOCK_SUCCESS',
	POST_EDIT_STOP_WITH_RESTOCK_FAILURE: 'POST_EDIT_STOP_WITH_RESTOCK_FAILURE',

	// HEADER CAROUSEL
	HEADER_CAROUSEL_STORE_ACTIVE_VALUE: 'HEADER_CAROUSEL_STORE_ACTIVE_VALUE',

	// INIT KIOSK MANAGER
	RESET_DATA_INIT_KIOSK_BUSINESS: 'RESET_DATA_INIT_KIOSK_BUSINESS',

	GET_INIT_KIOSKS_BUSINESS: 'GET_INIT_KIOSKS_BUSINESS',
	GET_INIT_KIOSKS_BUSINESS_SUCCESS: 'GET_INIT_KIOSKS_BUSINESS_SUCCESS',
	GET_INIT_KIOSKS_BUSINESS_FAILURE: 'GET_INIT_KIOSKS_BUSINESS_FAILURE',

	RESET_DATA_INIT_KIOSK_CUSTOMER: 'RESET_DATA_INIT_KIOSK_CUSTOMER',

	GET_INIT_KIOSKS_CUSTOMER: 'GET_INIT_KIOSKS_CUSTOMER',
	GET_INIT_KIOSKS_CUSTOMER_SUCCESS: 'GET_INIT_KIOSKS_CUSTOMER_SUCCESS',
	GET_INIT_KIOSKS_CUSTOMER_FAILURE: 'GET_INIT_KIOSKS_CUSTOMER_FAILURE',

	// INIT KIOSK CREATION
	// STEP 1
	RESET_DATA_CREATION_DEFINITION_CUSTOMER: 'RESET_DATA_CREATION_DEFINITION_CUSTOMER',

	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_FAILURE',

	SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER: 'SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER',
	SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS: 'SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS',
	SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE: 'SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE',

	CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER: 'CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER',
	CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS: 'CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS',
	CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE: 'CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_CUSTOMER: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE',

	SET_REQUEST_CUSTOMER_PARAMS: 'SET_REQUEST_CUSTOMER_PARAMS',

	RESET_DATA_CREATION_DEFINITION_BUSINESS: 'RESET_DATA_CREATION_DEFINITION_BUSINESS',

	GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_FAILURE',

	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_FAILURE',

	SAVE_KIOSK_CREATION_DEFINITION_BUSINESS: 'SAVE_KIOSK_CREATION_DEFINITION_BUSINESS',
	SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS: 'SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS',
	SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE: 'SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE',

	CREATE_KIOSK_CREATION_DEFINITION_BUSINESS: 'CREATE_KIOSK_CREATION_DEFINITION_BUSINESS',
	CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS: 'CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS',
	CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE: 'CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE',

	SET_REQUEST_BUSINESS_PARAMS: 'SET_REQUEST_BUSINESS_PARAMS',

	GET_KIOSK_CREATION_DEFINITION_BUSINESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS',
	GET_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE: 'GET_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE',

	REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS: 'REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS',
	REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS: 'REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS',
	REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE: 'REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE',
	//RAFTERS

	// BANK DETAILS

	GET_KIOSK_CREATION_BANK_DETAILS: 'GET_KIOSK_CREATION_BANK_DETAILS',
	GET_KIOSK_CREATION_BANK_DETAILS_SUCCESS: 'GET_KIOSK_CREATION_BANK_DETAILS_SUCCESS',
	GET_KIOSK_CREATION_BANK_DETAILS_FAILURE: 'GET_KIOSK_CREATION_BANK_DETAILS_FAILURE',

	PUT_SAVE_BANK_DETAILS: 'PUT_SAVE_BANK_DETAILS',
	PUT_SAVE_BANK_DETAILS_SUCCESS: 'PUT_SAVE_BANK_DETAILS_SUCCESS',
	PUT_SAVE_BANK_DETAILS_FAILURE: 'PUT_SAVE_BANK_DETAILS_FAILURE',

	PUT_CONTINUE_BANK_DETAILS: 'PUT_CONTINUE_BANK_DETAILS',
	PUT_CONTINUE_BANK_DETAILS_SUCCESS: 'PUT_CONTINUE_BANK_DETAILS_SUCCESS',
	PUT_CONTINUE_BANK_DETAILS_FAILURE: 'PUT_CONTINUE_BANK_DETAILS_FAILURE',

	RESET_BANK_DETAILS: 'RESET_BANK_DETAILS',

	// ADD ITEMS

	POST_KIOSK_ADD_ITEMS: 'POST_KIOSK_ADD_ITEMS',
	POST_KIOSK_ADD_ITEMS_SUCCESS: 'POST_KIOSK_ADD_ITEMS_SUCCESS',
	POST_KIOSK_ADD_ITEMS_FAILURE: 'POST_KIOSK_ADD_ITEMS_FAILURE',

	PUT_KIOSK_LINK_ITEMS: 'PUT_KIOSK_LINK_ITEMS',
	PUT_KIOSK_LINK_ITEMS_SUCCESS: '	PUT_KIOSK_LINK_ITEMS_SUCCESS',
	PUT_KIOSK_LINK_ITEMS_FAILURE: '	PUT_KIOSK_LINK_ITEMS_FAILURE',

	PUT_KIOSK_UNLINK_ITEMS: 'PUT_KIOSK_UNLINK_ITEMS',
	PUT_KIOSK_UNLINK_ITEMS_SUCCESS: '	PUT_KIOSK_UNLINK_ITEMS_SUCCESS',
	PUT_KIOSK_UNLINK_ITEMS_FAILURE: '	PUT_KIOSK_UNLINK_ITEMS_FAILURE',

	GET_KIOSK_ITEMS_VALIDATE: 'GET_KIOSK_ITEMS_VALIDATE',
	GET_KIOSK_ITEMS_VALIDATE_SUCCESS: 'GET_KIOSK_ITEMS_VALIDATE_SUCCESS',
	GET_KIOSK_ITEMS_VALIDATE_FAILURE: 'GET_KIOSK_ITEMS_VALIDATE_FAILURE',

	SET_IS_UPDATED: 'SET_IS_UPDATED',

	RESET_DATA_ADD_ITEMS: 'RESET_DATA_ADD_ITEMS',

	// ADD PRICES

	POST_KIOSK_ADD_PRICES: 'POST_KIOSK_ADD_PRICES',
	POST_KIOSK_ADD_PRICES_SUCCESS: 'POST_KIOSK_ADD_PRICES_SUCCESS',
	POST_KIOSK_ADD_PRICES_FAILURE: 'POST_KIOSK_ADD_PRICES_FAILURE',

	PUT_UPDATE_PRICES: 'PUT_UPDATE_PRICES',
	PUT_UPDATE_PRICES_SUCCESS: 'PUT_UPDATE_PRICES_SUCCESS',
	PUT_UPDATE_PRICES_FAILURE: 'PUT_UPDATE_PRICES_FAILURE',

	PUT_VALIDATE_PRICES: 'PUT_VALIDATE_PRICES',
	PUT_VALIDATE_PRICES_SUCCESS: 'PUT_VALIDATE_PRICES_SUCCESS',
	PUT_VALIDATE_PRICES_FAILURE: 'PUT_VALIDATE_PRICES_FAILURE',

	RESET_DATA_ADD_PRICES: 'RESET_DATA_ADD_PRICES',

	// KIOSK START BUILD

	PUT_KIOSK_BUILD: 'PUT_KIOSK_BUILD',
	PUT_KIOSK_BUILD_SUCCESS: 'PUT_KIOSK_BUILD_SUCCESS',
	PUT_KIOSK_BUILD_FAILURE: 'PUT_KIOSK_BUILD_FAILURE',

	VIEW_PRODUCTION_SHEET: 'VIEW_PRODUCTION_SHEET',
	VIEW_PRODUCTION_SHEET_SUCCESS: 'VIEW_PRODUCTION_SHEET_SUCCESS',
	VIEW_PRODUCTION_SHEET_FAILURE: 'VIEW_PRODUCTION_SHEET_FAILURE',

	// KIOSK IMPLANTATION

	POST_KIOSK_IMPLANTATION: 'POST_KIOSK_IMPLANTATION',
	POST_KIOSK_IMPLANTATION_SUCCESS: 'POST_KIOSK_IMPLANTATION_SUCCESS',
	POST_KIOSK_IMPLANTATION_FAILURE: 'POST_KIOSK_IMPLANTATION_FAILURE',

	GET_ITEMS_CATALOG_GROWTH: 'GET_ITEMS_CATALOG_GROWTH',
	GET_ITEMS_CATALOG_GROWTH_SUCCESS: 'GET_ITEMS_CATALOG_GROWTH_SUCCESS',
	GET_ITEMS_CATALOG_GROWTH_FAILURE: 'GET_ITEMS_CATALOG_GROWTH_FAILURE',

	PUT_VALIDATE_IMPLANTATION: 'PUT_VALIDATE_IMPLANTATION',
	PUT_VALIDATE_IMPLANTATION_SUCCESS: 'PUT_VALIDATE_IMPLANTATION_SUCCESS',
	PUT_VALIDATE_IMPLANTATION_FAILURE: 'PUT_VALIDATE_IMPLANTATION_FAILURE',

	RESET_DATA_IMPLANTATION: 'RESET_DATA_IMPLANTATION',
	RESET_ERROR_IMPLANTATION: 'RESET_ERROR_IMPLANTATION',

	SET_STORED_DATAS: 'SET_STORED_DATAS',

	//-----------------------KIOSK IMPLANTATION ACTIONS------------------//

	PUT_UNIT_ACTION_WITH_ID: 'PUT_UNIT_ACTION_WITH_ID',
	PUT_UNIT_ACTION_WITH_ID_SUCCESS: 'PUT_UNIT_ACTION_WITH_ID_SUCCESS',
	PUT_UNIT_ACTION_WITH_ID_FAILURE: 'PUT_UNIT_ACTION_WITH_ID_FAILURE',

	// KIOSK CREATION SUMMARY

	RESET_DATA_CREATION_SUMMARY: 'RESET_DATA_CREATION_SUMMARY',

	GET_KIOSK_CREATION_SUMMARY_CUSTOMER: 'GET_KIOSK_CREATION_SUMMARY_CUSTOMER',
	GET_KIOSK_CREATION_SUMMARY_CUSTOMER_SUCCESS: 'GET_KIOSK_CREATION_SUMMARY_CUSTOMER_SUCCESS',
	GET_KIOSK_CREATION_SUMMARY_CUSTOMER_FAILURE: 'GET_KIOSK_CREATION_SUMMARY_CUSTOMER_FAILURE',

	SET_SUMMARY_CONFIG_FINISHED_CUSTOMER: 'SET_SUMMARY_CONFIG_FINISHED_CUSTOMER',
	SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_SUCCESS: 'SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_SUCCESS',
	SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_FAILURE: 'SET_SUMMARY_CONFIG_FINISHED_CUSTOMER_FAILURE',

	GET_KIOSK_CREATION_SUMMARY_BUSINESS: 'GET_KIOSK_CREATION_SUMMARY_BUSINESS',
	GET_KIOSK_CREATION_SUMMARY_BUSINESS_SUCCESS: 'GET_KIOSK_CREATION_SUMMARY_BUSINESS_SUCCESS',
	GET_KIOSK_CREATION_SUMMARY_BUSINESS_FAILURE: 'GET_KIOSK_CREATION_SUMMARY_BUSINESS_FAILURE',

	SET_SUMMARY_CONFIG_FINISHED_BUSINESS: 'SET_SUMMARY_CONFIG_FINISHED_BUSINESS',
	SET_SUMMARY_CONFIG_FINISHED_BUSINESS_SUCCESS: 'SET_SUMMARY_CONFIG_FINISHED_BUSINESS_SUCCESS',
	SET_SUMMARY_CONFIG_FINISHED_BUSINESS_FAILURE: 'SET_SUMMARY_CONFIG_FINISHED_BUSINESS_FAILURE',

	SET_SUMMARY_TRIGGER_BUILD: 'SET_SUMMARY_TRIGGER_BUILD',
	SET_SUMMARY_TRIGGER_BUILD_SUCCESS: 'SET_SUMMARY_TRIGGER_BUILD_SUCCESS',
	SET_SUMMARY_TRIGGER_BUILD_FAILURE: 'SET_SUMMARY_TRIGGER_BUILD_FAILURE',

	// KIOSK PRODUCTION LIST
	RESET_DATA_KIOSK_PRODUCTION_LIST: 'RESET_DATA_KIOSK_PRODUCTION_LIST',
	GET_KIOSK_PRODUCTION_LIST: 'GET_KIOSK_PRODUCTION_LIST',
	GET_KIOSK_PRODUCTION_LIST_SUCCESS: 'GET_KIOSK_PRODUCTION_LIST_SUCCESS',
	GET_KIOSK_PRODUCTION_LIST_FAILURE: 'GET_KIOSK_PRODUCTION_LIST_FAILURE',

	GET_KIOSK_PRODUCTION_INFOS_SIMCARD: 'GET_KIOSK_PRODUCTION_INFOS_SIMCARD',
	GET_KIOSK_PRODUCTION_INFOS_SIMCARD_SUCCESS: 'GET_KIOSK_PRODUCTION_INFOS_SIMCARD_SUCCESS',
	GET_KIOSK_PRODUCTION_INFOS_SIMCARD_FAILURE: 'GET_KIOSK_PRODUCTION_INFOS_SIMCARD_FAILURE',

	GET_KIOSK_PRODUCTION_INFOS_BATTERY: 'GET_KIOSK_PRODUCTION_INFOS_BATTERY',
	GET_KIOSK_PRODUCTION_INFOS_BATTERY_SUCCESS: 'GET_KIOSK_PRODUCTION_INFOS_BATTERY_SUCCESS',
	GET_KIOSK_PRODUCTION_INFOS_BATTERY_FAILURE: 'GET_KIOSK_PRODUCTION_INFOS_BATTERY_FAILURE',

	GET_KIOSK_PRODUCTION_INFOS_WS: 'GET_KIOSK_PRODUCTION_INFOS_WS',
	GET_KIOSK_PRODUCTION_INFOS_WS_SUCCESS: 'GET_KIOSK_PRODUCTION_INFOS_WS_SUCCESS',
	GET_KIOSK_PRODUCTION_INFOS_WS_FAILURE: 'GET_KIOSK_PRODUCTION_INFOS_WS_FAILURE',

	// KIOSK DIAGNOSTIC
	RESET_DATA_KIOSK_DIAGNOSTIC: 'RESET_DATA_KIOSK_DIAGNOSTIC',
	POST_KIOSK_DIAGNOSTIC: 'POST_KIOSK_DIAGNOSTIC',
	POST_KIOSK_DIAGNOSTIC_SUCCESS: 'POST_KIOSK_DIAGNOSTIC_SUCCESS',
	POST_KIOSK_DIAGNOSTIC_FAILURE: 'POST_KIOSK_DIAGNOSTIC_FAILURE',

	// PRODUCT CATALOG DETAIL
	GET_ITEM_CATALOG_DETAIL: 'GET_ITEM_CATALOG_DETAIL',
	GET_ITEM_CATALOG_DETAIL_SUCCESS: 'GET_ITEM_CATALOG_DETAIL_SUCCESS',
	GET_ITEM_CATALOG_DETAIL_FAILURE: 'GET_ITEM_CATALOG_DETAIL_FAILURE',
	GET_ITEM_CATALOG_DETAIL_FILTERS_STOCKS: 'GET_ITEM_CATALOG_DETAIL_FILTERS_STOCKS',
	SET_ITEM_CATALOG_DETAIL_SALEBYARTICLE: 'SET_ITEM_CATALOG_DETAIL_SALEBYARTICLE',
	RESET_ITEM_CATALOG_DETAIL: 'RESET_ITEM_CATALOG_DETAIL',

	// ARTICLES CATALOG
	RESET_DATA_ITEM_CATALOG: 'RESET_DATA_ITEM_CATALOG',
	GET_ITEM_CATALOG: 'GET_ITEM_CATALOG',
	GET_ITEM_CATALOG_SUCCESS: 'GET_ITEM_CATALOG_SUCCESS',
	GET_ITEM_CATALOG_FAILURE: 'GET_ITEM_CATALOG_FAILURE',
	SET_ITEM_CATALOG_SALESBYCODE: 'SET_ITEM_CATALOG_SALESBYCODE',
	GET_ITEM_CATALOG_FILTERS_STOCKS: 'GET_ITEM_CATALOG_FILTERS_STOCKS',
	SET_ITEM_CATALOG_SALEBYARTICLE: 'SET_ITEM_CATALOG_SALEBYARTICLE',

	GET_SALE_ORDER_BY_CODE: 'GET_SALE_ORDER_BY_CODE',
	GET_SALE_ORDER_BY_CODE_SUCCESS: 'GET_SALE_ORDER_BY_CODE_SUCCESS',
	GET_SALE_ORDER_BY_CODE_FAILURE: 'GET_SALE_ORDER_BY_CODE_FAILURE',

	POST_CREATE_CODE: 'POST_CREATE_CODE',
	POST_CREATE_CODE_SUCCESS: 'POST_CREATE_CODE_SUCCESS',
	POST_CREATE_CODE_FAILURE: 'POST_CREATE_CODE_FAILURE',

	POST_SEND_CODE: 'POST_SEND_CODE',
	POST_SEND_CODE_SUCCESS: 'POST_SEND_CODE_SUCCESS',
	POST_SEND_CODE_FAILURE: 'POST_SEND_CODE_FAILURE',

	SET_IS_CLOSED_MODAL: 'SET_IS_CLOSED_MODAL',

	SET_IS_TO_UPDATE: 'SET_IS_TO_UPDATE',

	// COLUMNS
	SET_COLUMNS: 'SET_COLUMNS',
	SET_TABLE_HEIGHT: 'SET_TABLE_HEIGHT',
	SET_IS_EDITING_TRIGGER: 'SET_IS_EDITING_TRIGGER',
	SET_IS_EDITING_NOT_TRIGGER: 'SET_IS_EDITING_NOT_TRIGGER',
	SET_IS_VALIDATE_ENABLE: 'SET_IS_VALIDATE_ENABLE',
	SET_IS_RESET_FORM: 'SET_IS_RESET_FORM',
	SET_FORM_BUTTON_WIDTH: 'SET_FORM_BUTTON_WIDTH',
	SET_IS_SINGLE_EDIT: 'SET_IS_SINGLE_EDIT',
	SET_IS_SEARCHFIELD_UPDATED: 'SET_IS_SEARCHFIELD_UPDATED',
	SET_CURRENT_COLUMN: 'SET_CURRENT_COLUMN',
	SET_CURRENT_DIR: 'SET_CURRENT_DIR',

	// KIOSK EDIT SETUP
	GET_KIOSK_SETUP: 'GET_KIOSK_SETUP',
	GET_KIOSK_SETUP_SUCCESS: 'GET_KIOSK_SETUP_SUCCESS',
	GET_KIOSK_SETUP_FAILURE: 'GET_KIOSK_SETUP_FAILURE',

	PUT_EDIT_KIOSK_SETUP: 'PUT_EDIT_KIOSK_SETUP',
	PUT_EDIT_KIOSK_SETUP_SUCCESS: 'PUT_EDIT_KIOSK_SETUP_SUCCESS',
	PUT_EDIT_KIOSK_SETUP_FAILURE: 'PUT_EDIT_KIOSK_SETUP_FAILURE',

	VIEW_PRODUCTION_FILE: 'VIEW_PRODUCTION_FILE',
	VIEW_PRODUCTION_FILE_SUCCESS: 'VIEW_PRODUCTION_FILE_SUCCESS',
	VIEW_PRODUCTION_FILE_FAILURE: 'VIEW_PRODUCTION_FILE_FAILURE',

	// KIOSK RACKS REQUEST
	RESET_DATA_KIOSK_RACKS_REQUEST: 'RESET_DATA_KIOSK_RACKS_REQUEST',

	GET_KIOSK_RACKS_REQUEST: 'GET_KIOSK_RACKS_REQUEST',
	GET_KIOSK_RACKS_REQUEST_SUCCESS: 'GET_KIOSK_RACKS_REQUEST_SUCCESS',
	GET_KIOSK_RACKS_REQUEST_FAILURE: 'GET_KIOSK_RACKS_REQUEST_FAILURE',

	GET_KIOSK_RACKS_REQUEST_FORM: 'GET_KIOSK_RACKS_REQUEST_FORM',
	GET_KIOSK_RACKS_REQUEST_FORM_SUCCESS: 'GET_KIOSK_RACKS_REQUEST_FORM_SUCCESS',
	GET_KIOSK_RACKS_REQUEST_FORM_FAILURE: 'GET_KIOSK_RACKS_REQUEST_FORM_FAILURE',

	POST_KIOSK_RACKS_REQUEST_ADD_RACK: 'POST_KIOSK_RACKS_REQUEST_ADD_RACK',
	POST_KIOSK_RACKS_REQUEST_ADD_RACK_SUCCESS: 'POST_KIOSK_RACKS_REQUEST_ADD_RACK_SUCCESS',
	POST_KIOSK_RACKS_REQUEST_ADD_RACK_FAILURE: 'POST_KIOSK_RACKS_REQUEST_ADD_RACK_FAILURE',

	POST_KIOSK_RACKS_REQUEST_UPDATE_RACK: 'POST_KIOSK_RACKS_REQUEST_UPDATE_RACK',
	POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_SUCCESS: 'POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_SUCCESS',
	POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_FAILURE: 'POST_KIOSK_RACKS_REQUEST_UPDATE_RACK_FAILURE',

	POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST: 'POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST',
	POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_SUCCESS: 'POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_SUCCESS',
	POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_FAILURE: 'POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST_FAILURE',

	PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST: 'PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST',
	PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_SUCCESS: 'PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_SUCCESS',
	PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_FAILURE: 'PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST_FAILURE',

	PUT_KIOSK_RACKS_REQUEST_DELETE_RACK: 'PUT_KIOSK_RACKS_REQUEST_DELETE_RACK',
	PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_SUCCESS: 'PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_SUCCESS',
	PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_FAILURE: 'PUT_KIOSK_RACKS_REQUEST_DELETE_RACK_FAILURE',

	// KIOSK EDIT IMPLANTATION
	RESET_DATA_EDIT_IMPLANTATION: 'RESET_DATA_EDIT_IMPLANTATION',
	RESET_ERROR_EDIT_IMPLANTATION: 'RESET_ERROR_EDIT_IMPLANTATION',

	POST_KIOSK_EDIT_IMPLANTATION: 'POST_KIOSK_EDIT_IMPLANTATION',
	POST_KIOSK_EDIT_IMPLANTATION_SUCCESS: 'POST_KIOSK_EDIT_IMPLANTATION_SUCCESS',
	POST_KIOSK_EDIT_IMPLANTATION_FAILURE: 'POST_KIOSK_EDIT_IMPLANTATION_FAILURE',

	POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID: 'POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID',
	POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_SUCCESS: 'POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_SUCCESS',
	POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_FAILURE: 'POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_FAILURE',

	GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH: 'GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH',
	GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_SUCCESS: 'GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_SUCCESS',
	GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_FAILURE: 'GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_FAILURE',

	PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION: 'PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION',
	PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_SUCCESS: 'PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_SUCCESS',
	PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_FAILURE: 'PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_FAILURE',

	// LANGUAGES MANAGER
	GET_LANGUAGES: 'GET_LANGUAGES',
	GET_LANGUAGES_SUCCESS: 'GET_LANGUAGES_SUCCESS',
	GET_LANGUAGES_FAILURE: 'GET_LANGUAGES_FAILURE',

	PUT_LANGUAGE_ENABLING: 'PUT_LANGUAGE_ENABLING',
	PUT_LANGUAGE_ENABLING_SUCCESS: 'PUT_LANGUAGE_ENABLING_SUCCESS',
	PUT_LANGUAGE_ENABLING_FAILURE: 'PUT_LANGUAGE_ENABLING_FAILURE',

	RESET_DATA_LANGUAGES_MANAGER: 'RESET_DATA_LANGUAGES_MANAGER',

	GET_LANGUAGE_DETAIL: 'GET_LANGUAGE_DETAIL',
	GET_LANGUAGE_DETAIL_SUCCESS: 'GET_LANGUAGE_DETAIL_SUCCESS',
	GET_LANGUAGE_DETAIL_FAILURE: 'GET_LANGUAGE_DETAIL_FAILURE',

	POST_CREATE_LANGUAGE_DETAIL: 'POST_CREATE_LANGUAGE_DETAIL',
	POST_CREATE_LANGUAGE_DETAIL_SUCCESS: 'POST_CREATE_LANGUAGE_DETAIL_SUCCESS',
	POST_CREATE_LANGUAGE_DETAIL_FAILURE: 'POST_CREATE_LANGUAGE_DETAIL_FAILURE',

	POST_UPDATE_LANGUAGE_DETAIL: 'POST_UPDATE_LANGUAGE_DETAIL',
	POST_UPDATE_LANGUAGE_DETAIL_SUCCESS: 'POST_UPDATE_LANGUAGE_DETAIL_SUCCESS',
	POST_UPDATE_LANGUAGE_DETAIL_FAILURE: 'POST_UPDATE_LANGUAGE_DETAIL_FAILURE',

	RESET_DATA_LANGUAGE_DETAIL: 'RESET_DATA_LANGUAGE_DETAIL',

	// TABLE
	SET_SAVED_TABLE_COLUMNS_DISPLAY: 'SET_SAVED_TABLE_COLUMNS_DISPLAY',
	SET_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS: 'SET_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS',
	SET_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE: 'SET_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE',

	GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY: 'GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY',
	GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS: 'GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS',
	GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE: 'GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE',

	SET_SAVED_PAGGING_CONFIG: 'SET_SAVED_PAGGING_CONFIG',
	RESET_PAGGING_CONFIG: 'RESET_PAGGING_CONFIG',
	SET_IS_FROM_REDIRECT: 'SET_IS_FROM_REDIRECT',

	// Sales Control
	GET_SALES_CONTROL: 'GET_SALES_CONTROL',
	GET_SALES_CONTROL_SUCCESS: 'GET_SALES_CONTROL_SUCCESS',
	GET_SALES_CONTROL_FAILURE: 'GET_SALES_CONTROL_FAILURE',

	RESET_SALES_CONTROL_ITEMS: 'RESET_SALES_CONTROL_ITEMS',

	POST_EXPORT_DATAS_BY_EMAIL: 'POST_EXPORT_DATAS_BY_EMAIL',
	POST_EXPORT_DATAS_BY_EMAIL_SUCCESS: 'POST_EXPORT_DATAS_BY_EMAIL_SUCCESS',
	POST_EXPORT_DATAS_BY_EMAIL_FAILURE: 'POST_EXPORT_DATAS_BY_EMAIL_FAILURE',
	RESET_EXPORT_DATAS_BY_EMAIL: 'RESET_EXPORT_DATAS_BY_EMAIL',
}

export default ActionsTypes
